/**
 * BossRushSequence — pure logic for Boss Rush mode sequencing.
 *
 * Defines the ordered list of bosses and helpers for progressing through them.
 * No Phaser import — fully testable in Node.
 */

/** Boss Rush shared health pool (limited lives spanning all 9 encounters). */
export const BOSS_RUSH_LIVES = 3;

/** Ordered sequence of boss IDs as they appear in Boss Rush mode. */
export const BOSS_RUSH_SEQUENCE: readonly string[] = [
  'the-bargee',
  'the-ferryman',
  'the-conductor',
  'doorman-rex',
  'the-hedge-fund',
  'halloway-astor',
  'the-chemist',
  'comrade-vex',
  'captain-vlad',
];

export interface BossRushProgress {
  /** Whether all bosses have been defeated. */
  done: boolean;
  /** Id of the next boss to fight, or null when done. */
  nextBossId: string | null;
  /** 0-based index of the next boss (same as bossesDefeated when not done). */
  nextIndex: number;
}

/**
 * Given how many bosses have been defeated, return the next boss to fight.
 *
 * @param bossesDefeated Number of bosses beaten so far (0..9).
 */
export function bossRushProgress(bossesDefeated: number): BossRushProgress {
  const nextIndex = bossesDefeated;
  if (nextIndex >= BOSS_RUSH_SEQUENCE.length) {
    return { done: true, nextBossId: null, nextIndex };
  }
  return { done: false, nextBossId: BOSS_RUSH_SEQUENCE[nextIndex], nextIndex };
}

/**
 * Returns the score-attack grade multiplier for a given stage (1-indexed).
 * Later stages in Score Attack yield more points to reward progression.
 */
export function scoreAttackStageMultiplier(stage: number): number {
  return 1 + (stage - 1) * 0.25;
}
